import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createBlock as _createBlock, mergeProps as _mergeProps, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "js-step-3" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "o-grid u-mar-t-1" }
const _hoisted_4 = { class: "o-grid__cell o-grid__cell--4-1024 o-grid__cell--12-360" }
const _hoisted_5 = {
  key: 0,
  class: "u-form-heading"
}
const _hoisted_6 = {
  key: 1,
  class: "u-form-heading"
}
const _hoisted_7 = { class: "o-grid__cell o-grid__cell--6-1024 o-grid__cell--12-360" }
const _hoisted_8 = ["required"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["required", "aria-required"]
const _hoisted_11 = ["required", "aria-required"]
const _hoisted_12 = ["required", "aria-required"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Steps = _resolveComponent("Steps")!
  const _component_antragsteller = _resolveComponent("antragsteller")!
  const _component_vertragsunterlagen_digital = _resolveComponent("vertragsunterlagen-digital")!
  const _component_icon_sprite = _resolveComponent("icon-sprite")!
  const _component_info_box = _resolveComponent("info-box")!
  const _component_titel_zelle = _resolveComponent("titel-zelle")!
  const _component_validierungs_fehler = _resolveComponent("validierungs-fehler")!
  const _component_zelle = _resolveComponent("zelle")!
  const _component_zeile = _resolveComponent("zeile")!
  const _component_zahlungsdaten = _resolveComponent("zahlungsdaten")!
  const _component_vorversicherung = _resolveComponent("vorversicherung")!
  const _component_vorschaeden = _resolveComponent("vorschaeden")!
  const _component_ueberschrift = _resolveComponent("ueberschrift")!
  const _component_datei_upload = _resolveComponent("datei-upload")!
  const _component_sanierungsfragen = _resolveComponent("sanierungsfragen")!
  const _component_hug_mitgliedschaft = _resolveComponent("hug-mitgliedschaft")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Steps, {
      items: _ctx.navItems,
      active: 3,
      onGotoPage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('goto-page', $event)))
    }, null, 8, ["items"]),
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_antragsteller, {
        fehler: _ctx.fehler,
        ref: "antragstellerRef"
      }, null, 8, ["fehler"]),
      _createVNode(_component_vertragsunterlagen_digital, { fehler: _ctx.fehler }, null, 8, ["fehler"]),
      (_ctx.hatMitversichertePerson())
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (!_ctx.piniaStore.state.isMakler)
                  ? (_openBlock(), _createElementBlock("h2", _hoisted_5, "Mitversicherter Lebenspartner"))
                  : (_openBlock(), _createElementBlock("h2", _hoisted_6, [
                      _cache[8] || (_cache[8] = _createTextVNode(" Mitversicherte Person")),
                      _createElementVNode("span", {
                        class: "c-notice-icon",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.wechsleSichtbarkeit('mitversichertePersonInfo')))
                      }, [
                        _createVNode(_component_icon_sprite, { "icon-name": "icon-info-i" })
                      ])
                    ]))
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_info_box, { id: "mitversichertePersonInfo" }, {
                  default: _withCtx(() => _cache[9] || (_cache[9] = [
                    _createTextVNode(" Hier können Sie die Mitversicherung eines in häuslicher Gemeinschaft lebenden volljährigen Partners veranlassen. Kinder werden automatisch berücksichtigt und sind nicht separat zu erfassen. ")
                  ])),
                  _: 1,
                  __: [9]
                })
              ])
            ]),
            _createVNode(_component_zeile, null, {
              default: _withCtx(() => [
                _createVNode(_component_titel_zelle, null, {
                  default: _withCtx(() => _cache[10] || (_cache[10] = [
                    _createTextVNode("Art der Partnerschaft")
                  ])),
                  _: 1,
                  __: [10]
                }),
                _createVNode(_component_zelle, null, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("select", {
                      id: "typeOfPartnership",
                      name: "typeOfPartnership",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.piniaStore.state.personendaten.mitversichertePerson.artDerPartnerschaft) = $event)),
                      "data-cy": "typeOfPartnership",
                      class: "c-form-control-select",
                      required: _ctx.hatMitversichertePerson()
                    }, _cache[11] || (_cache[11] = [
                      _createElementVNode("option", {
                        selected: "",
                        value: ""
                      }, "Bitte wählen", -1),
                      _createElementVNode("option", { value: "1" }, "Ehe/eingetragene Lebenspartnerschaft", -1),
                      _createElementVNode("option", { value: "2" }, "Häusliche Gemeinschaft", -1)
                    ]), 8, _hoisted_8), [
                      [
                        _vModelSelect,
                        _ctx.piniaStore.state.personendaten.mitversichertePerson.artDerPartnerschaft,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    _createVNode(_component_validierungs_fehler, {
                      "fehler-text": _ctx.fehler.typeOfPartnership,
                      "reduzierter-abstand": true
                    }, null, 8, ["fehler-text"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.isHaeuslicheGemeinschaft)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                  _createVNode(_component_zeile, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_titel_zelle, null, {
                        default: _withCtx(() => _cache[12] || (_cache[12] = [
                          _createTextVNode("Vorname und Name")
                        ])),
                        _: 1,
                        __: [12]
                      }),
                      _createVNode(_component_zelle, { breite: 3 }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            id: "partnerFirstname",
                            name: "partnerFirstname",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.piniaStore.state.personendaten.mitversichertePerson.vorname) = $event)),
                            "data-cy": "partnerFirstname",
                            class: "c-form-control__input",
                            placeholder: "Vorname",
                            minlength: "2",
                            maxlength: "40",
                            required: _ctx.isHaeuslicheGemeinschaft,
                            "aria-required": _ctx.isHaeuslicheGemeinschaft,
                            "aria-label": "Vorname des Partners",
                            "data-fehlermeldung": "Bitte geben den Vornamen ein (2-40 Zeichen)."
                          }, null, 8, _hoisted_10), [
                            [
                              _vModelText,
                              _ctx.piniaStore.state.personendaten.mitversichertePerson.vorname,
                              void 0,
                              {
                                lazy: true,
                                trim: true
                              }
                            ]
                          ]),
                          _createVNode(_component_validierungs_fehler, {
                            "fehler-text": _ctx.fehler.partnerFirstname
                          }, null, 8, ["fehler-text"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_zelle, { breite: 3 }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            id: "partnerLastname",
                            name: "partnerLastname",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.piniaStore.state.personendaten.mitversichertePerson.nachname) = $event)),
                            "data-cy": "partnerLastname",
                            class: "c-form-control__input",
                            placeholder: "Name",
                            minlength: "2",
                            maxlength: "40",
                            required: _ctx.isHaeuslicheGemeinschaft,
                            "aria-required": _ctx.isHaeuslicheGemeinschaft,
                            "aria-label": "Nachname des Partners",
                            "data-parsley-combined-name-length": "40",
                            "data-fehlermeldung": "Bitte geben den Nachnamen ein (2-40 Zeichen)."
                          }, null, 8, _hoisted_11), [
                            [
                              _vModelText,
                              _ctx.piniaStore.state.personendaten.mitversichertePerson.nachname,
                              void 0,
                              {
                                lazy: true,
                                trim: true
                              }
                            ]
                          ]),
                          _createVNode(_component_validierungs_fehler, {
                            "fehler-text": _ctx.fehler.partnerLastname
                          }, null, 8, ["fehler-text"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_zeile, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_titel_zelle, null, {
                        default: _withCtx(() => _cache[13] || (_cache[13] = [
                          _createTextVNode("Geburtsdatum")
                        ])),
                        _: 1,
                        __: [13]
                      }),
                      _createVNode(_component_zelle, { breite: 3 }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            type: "date",
                            id: "partnerBirthdate",
                            name: "partnerBirthdate",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.piniaStore.state.personendaten.mitversichertePerson.geburtsdatum) = $event)),
                            "data-cy": "partnerBirthdate",
                            class: "c-form-control__input",
                            placeholder: "TT.MM.JJJJ",
                            title: "Geburtsdatum im Format TT.MM.JJJJ",
                            required: _ctx.isHaeuslicheGemeinschaft,
                            "aria-required": _ctx.isHaeuslicheGemeinschaft,
                            "aria-label": "Geburtsdatum im im Format TT.MM.JJJJ",
                            "data-checkalter18bis100": "true"
                          }, null, 8, _hoisted_12), [
                            [
                              _vModelText,
                              _ctx.piniaStore.state.personendaten.mitversichertePerson.geburtsdatum,
                              void 0,
                              {
                                lazy: true,
                                trim: true
                              }
                            ]
                          ]),
                          _createVNode(_component_validierungs_fehler, {
                            "fehler-text": _ctx.fehler.partnerBirthdate
                          }, null, 8, ["fehler-text"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_zahlungsdaten, {
        fehler: _ctx.fehler,
        ref: "zahlungsdatenRef"
      }, null, 8, ["fehler"]),
      _createVNode(_component_vorversicherung, { fehler: _ctx.fehler }, null, 8, ["fehler"]),
      _createVNode(_component_vorschaeden, { fehler: _ctx.fehler }, null, 8, ["fehler"]),
      (_ctx.isMakler)
        ? (_openBlock(), _createBlock(_component_ueberschrift, {
            key: 1,
            titel: "Dateien hochladen",
            "zeige-info": true,
            "info-box-id": "dateienInfo"
          }))
        : _createCommentVNode("", true),
      (_ctx.isMakler)
        ? (_openBlock(), _createBlock(_component_zeile, { key: 2 }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, null, {
                default: _withCtx(() => _cache[14] || (_cache[14] = [
                  _createTextVNode("Zur Antragstellung benötigen wir folgende Dokumente von Ihnen:")
                ])),
                _: 1,
                __: [14]
              }),
              _createVNode(_component_zelle, null, {
                default: _withCtx(() => [
                  _createVNode(_component_info_box, { id: "dateienInfo" }, {
                    default: _withCtx(() => _cache[15] || (_cache[15] = [
                      _createTextVNode(" Sie können Dokumente bis zu 10 MB hochladen. "),
                      _createElementVNode("br", null, null, -1),
                      _createTextVNode("Zulässige Dateiformate: .jpeg, .jpg, .png, .pdf und .tiff. ")
                    ])),
                    _: 1,
                    __: [15]
                  }),
                  (_ctx.zeigeHochladenGebaeudefotos)
                    ? (_openBlock(), _createBlock(_component_datei_upload, {
                        key: 0,
                        id: "hochladenGebaeudefotos",
                        ueberschrift: "Fotos von jeder Gebäudeseite (inkl. Dach)"
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.zeigeHochladenSicherungskasten)
                    ? (_openBlock(), _createBlock(_component_datei_upload, {
                        key: 1,
                        id: "hochladenSicherungskasten",
                        ueberschrift: "Foto vom geöffneten Sicherungskasten"
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.zeigeHochladenSanitaerbereich)
                    ? (_openBlock(), _createBlock(_component_datei_upload, {
                        key: 2,
                        id: "hochladenSanitaerbereich",
                        ueberschrift: "Fotos von Sanitärbereich, Heizungsanlage und Wasserversorgung"
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.zeigeHochladenElementar)
                    ? (_openBlock(), _createBlock(_component_datei_upload, {
                        key: 3,
                        id: "hochladenElementar",
                        ueberschrift: "Fragebogen Elementar",
                        "ueberschrift-download-link": "https://www.gev-versicherung.de/downloads/pdf/AZ-EL-Elementarfragebogen.pdf",
                        fileCount: 1,
                        dokumentart: "Elementarbogen"
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.zeigeHochladenDenkmalschutz)
                    ? (_openBlock(), _createBlock(_component_datei_upload, {
                        key: 4,
                        id: "hochladenDenkmalschutz",
                        ueberschrift: "Fragebogen Denkmalschutz",
                        "ueberschrift-download-link": "https://www.gev-versicherung.de/downloads/pdf/AZ-VG-Denkmalschutzbogen.pdf",
                        fileCount: 1,
                        dokumentart: "FragenbogenDenkmalschutz"
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_datei_upload, {
                    id: "hochladenDateien",
                    ueberschrift: "Andere Dokumente hinzufügen"
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.sanierungsfragenAnzeigenMakler || _ctx.sanierungsfragenAnzeigenDirekt)
        ? (_openBlock(), _createBlock(_component_sanierungsfragen, {
            key: 3,
            aelterAls50: _ctx.aelterAls50,
            fehler: _ctx.fehler
          }, null, 8, ["aelterAls50", "fehler"]))
        : _createCommentVNode("", true),
      (_ctx.zeigeFrageHugNachlass)
        ? (_openBlock(), _createBlock(_component_hug_mitgliedschaft, {
            key: 4,
            fehler: _ctx.fehler
          }, null, 8, ["fehler"]))
        : _createCommentVNode("", true),
      _createVNode(_component_zeile, null, {
        default: _withCtx(() => [
          _createVNode(_component_zelle, {
            offset: 4,
            breite: 4
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                class: "c-button c-button--full-width u-mar-t-2 u-mar-b-2 mobil-mehrAbstand",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.nextPage())),
                "data-cy": "submitIhreDaten"
              }, " Zusammenfassung und Abschluss ")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    (_ctx.istSichtbar('modalBeitragsaenderung'))
      ? (_openBlock(), _createBlock(_component_modal, _mergeProps({ key: 0 }, _ctx.modalBeitragsaenderung, {
          onCloseModal: _cache[7] || (_cache[7] = ($event: any) => (_ctx.wechsleSichtbarkeit('modalBeitragsaenderung')))
        }), null, 16))
      : _createCommentVNode("", true)
  ], 64))
}